
import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../Services/common.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';

import { MatPaginator, MatSort, MatTableDataSource, ErrorStateMatcher } from '@angular/material';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { debug } from 'util';
import { AppDataService } from "../../Services/app-data-service";
import { DatePipe } from '@angular/common';

declare var config: any;
@Component({
  selector: 'app-PhoneGradingDeduction',
  templateUrl: './PhoneGradingDeduction.component.html',
  styleUrls: ['./PhoneGradingDeduction.component.css']
})
export class PhoneGradingDeductionComponent implements OnInit {


  public freshRecords : any [];
  public Userlist;
  public selectedEnterprise;
  public UserInfo
  enterpriseClientData: any;
  UserData: any;
  EnterprisePartenerModalList: any;
  StoreDetails: any;
  AllStoreDetails: any;
  RecordsList: any[];
  GradeList: any[];
  GradePrice: any[] = [];
  ShowGrade: any[] = [];
  SaveGradeList: any[] = [];
  IsSubmit: boolean = false;
  IsDisabled:boolean= true;
  SearchSKUID: '';
  SearchMakeModel: '';
  disableReset: boolean = true;

  DeviceCategoryList: any;
  DeviceCategoryID: any=config.DeviceCategoryID;
  DeviceCategory: any='Phones & iPad';

  public GradeDataList:any;

  public Datemodel: any;
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: false,
    disableUntil: { year: (new Date()).getFullYear(), month: (new Date()).getMonth() + 1, day: (new Date()).getDate() - 1 },
  };
  TemporaryData: any;
  PriceEdit: string;

  constructor(private fb: FormBuilder,
    private appData: AppDataService, private datePipe: DatePipe,
    private spinner: NgxSpinnerService, private _service: CommonService, private router: Router, private toasterservice: ToastrService) {

  }



  ngOnInit() {
    this.SearchSKUID = '';
    this.SearchMakeModel = '';
    this.UserInfo = JSON.parse(sessionStorage.getItem('user'));

    const datestring = sessionStorage.getItem('PriceSelectedDate');
    const myDate = new Date();
    
    debugger
    if (datestring) {
      const selectedDate = new Date(datestring);
     // const selectedDate = new Date(myDate);
      this.Datemodel = { date: { year: selectedDate.getFullYear(), month: selectedDate.getMonth() + 1, day: selectedDate.getDate() } };
    } else {
      this.Datemodel = { date: { year: (new Date()).getFullYear(), month: (new Date()).getMonth() + 1, day: (new Date()).getDate() } };
    }


    if (this.UserInfo == null) {
      this.router.navigate(['/login']);
    }

  //  this.getDeviceCategoryList();

   this.getDisplaySkuPricedata(config.DeviceCategoryID);
  }


  // getDeviceCategoryList() {
  //   this.spinner.show();
  //   this._service.Get('api/GetDeviceCategoryList/' + config.EnterprisePartnerID).then(result => {
  //    // this.spinner.hide();
  //     if (result && result != null) {
  //       this.DeviceCategoryList = result;
  //       this.DeviceCategoryID = 0;

  //       debugger
  //       const excelfilesData = JSON.parse(sessionStorage.getItem('Records'));
  //       if (excelfilesData) {
  //         this.DeviceCategoryList.forEach(element => {
  //           const CategoryData = excelfilesData.find(x => x.DeviceCategoryID === Number(element.DeviceCategoryID));
  //           if (CategoryData) {
  //             element.PriceEdit = 'price-warning';
  //           } else {
  //             element.PriceEdit = '';
  //           }
  //         });

  //       }

  //     }
  //     this.getDisplaySkuPricedata(1);
  //   },
  //     error => {
  //       console.log(error);
  //     }
  //   );
  // }
  // calculateCategoryprice(CategoryID) {
  //   debugger
  //   this.spinner.show();
  //   this.IsDisabled = true;
  //   this.DeviceCategoryID = CategoryID,
  //   this.CalculatePriceDeduction(CategoryID);
  //   this.spinner.hide();
  // }


 async getDisplaySkuPricedata(DeviceCategoryID) {
    debugger;
    this.spinner.show();
    this.IsDisabled = true;
    this.DeviceCategoryID = DeviceCategoryID;
    let CategoryData: any = [];
    const excelfilesData = JSON.parse(sessionStorage.getItem('Records'));
    if (excelfilesData) {
      CategoryData = excelfilesData.find(x => x.DeviceCategoryID === Number(DeviceCategoryID));
    }
    if (excelfilesData && CategoryData && CategoryData.SkuModelData && CategoryData.SkuModelData.length > 0) {
   
    
      this.CalculatePriceDeduction(DeviceCategoryID, CategoryData);

    } else {
      //================= get data from  DB =================
      this.spinner.show();
      const param = {
        EnterprisePartnerID: config.EnterprisePartnerID,
        IsModelOverride: true,
        DeviceCategoryID: DeviceCategoryID,
      };

    await this._service.getData(param, 'api/pricing-get-sku-models-price').then(res => {
debugger
 this.spinner.show();
        this.PriceEdit="price-success";
        res.forEach(element => {
          element.MaxPrice = element.DeviceFullPrice;
        });
        this.TemporaryData =  res.filter(x => x.DeviceCategoryID === this.DeviceCategoryID);
        this.GradeDataList = {
          SkuModelData : [],
          PriceEdit: "" 
        }
        this.GradeDataList.SkuModelData = res.filter(x => x.DeviceCategoryID === this.DeviceCategoryID);

        sessionStorage.setItem('TemporaryData', JSON.stringify(this.TemporaryData));
        // if(this.GradeDataList != undefined)
        // {
        //   this.GradeDataList.SkuModelData= '';
        // }
       
        // this.GradeDataList.SkuModelData= this.TemporaryData;
        // this.DeviceCategoryList.forEach(element => {
        //   element.SkuModelData = res.filter(x => x.DeviceCategoryID === element.DeviceCategoryID);
        // });
       
        this.spinner.hide();
      });

      //================= get data from  DB =================
    }
   
    if (excelfilesData) {
   debugger
        const CategoryData = excelfilesData.find(x => x.DeviceCategoryID === Number(this.DeviceCategoryID));
        if (CategoryData) {
          CategoryData.PriceEdit = 'price-warning';
        } 
        this.GradeDataList = CategoryData;
    }
  //  this.spinner.hide();
    console.log("data",this.GradeDataList)
   // this.DeviceCategoryList=CategoryData;

  }

  onDateChanged(event) {
    const formattedDate = new Date(event.formatted);
    const SkuModelListData = this.DeviceCategoryList.find(x => x.DeviceCategoryID === this.DeviceCategoryID).SkuModelData;

    SkuModelListData.forEach(element => {
      element.StartDate = formattedDate;
      element.DeviceFullPrice = element.MaxPrice == null ? element.DeviceFullPrice : element.MaxPrice;
    });
  }
  Save(isSubmitAll) {
    debugger;
    this.spinner.show();
    let datetext = this.Datemodel.date.month + '-' + this.Datemodel.date.day + '-' + this.Datemodel.date.year;
    let startdate = this.datePipe.transform(new Date(datetext), 'MM-dd-yyyy');

    var SkuModelListData: any ;
    if (isSubmitAll && isSubmitAll === true) {
       SkuModelListData = this.DeviceCategoryList.reduce((acc, val) => acc.concat(val.SkuModelData), []);

    } else {
      console.log(this.GradeDataList.SkuModelData);
      SkuModelListData = this.GradeDataList.SkuModelData;
    }


    const param = {
      data: SkuModelListData,
      EnterprisePartnerID: config.EnterprisePartnerID,
    };
    this._service.getPhoneData(param, 'api/save-phone-grade-price').then(res => {
      debugger
      if (res && res.data && res.data.length > 0) {
        if (isSubmitAll && isSubmitAll === true) {
          this.DeviceCategoryList.array.forEach(element => {
            element.PriceEdit = "price-success";
          });

        } else {
          this.GradeDataList.PriceEdit = 'price-success';
        }

        let excelfilesData = JSON.parse(sessionStorage.getItem('Records'));
        if (excelfilesData) {
          excelfilesData = excelfilesData.filter(x => x.DeviceCategoryID !== Number(this.DeviceCategoryID));

          sessionStorage.removeItem('Records');
          sessionStorage.setItem('Records', JSON.stringify(excelfilesData));
        }

        Array.from(document.querySelectorAll('.text-edited')).forEach(function (el) {
          el.classList.remove('text-edited');
        });


        debugger
        if (this.SearchSKUID !== '' || this.SearchMakeModel !== '') {
          this.disableReset = false;
   
        } else {
          this.disableReset = true;
        }

        this.IsDisabled = true;
        this.spinner.hide();
        this.toasterservice.success('Grade price added successfully');
      } else {
        this.spinner.hide();
        this.toasterservice.warning('Something went wrong ! Please try again later');
      }

      this.spinner.hide();
      const myDate = new Date();
      const selectedDate = new Date(myDate);
      this.Datemodel = { date: { year: selectedDate.getFullYear(), month: selectedDate.getMonth() + 1, day: selectedDate.getDate() } };

    });
  }




  CalculatePriceDeduction(DeviceCategoryID, CategoryData) {
    debugger;
    const formatteddate = this.Datemodel.date.month + '/' + this.Datemodel.date.day + '/' + this.Datemodel.date.year;

    // this.GradeList = JSON.parse(sessionStorage.getItem('array'));

    // const deduction_a = this.GradeList.find(x => x.GradeID === 1).Deduction;
    // const deduction_b = this.GradeList.find(x => x.GradeID === 2).Deduction;
    // const deduction_c = this.GradeList.find(x => x.GradeID === 3).Deduction;
    // const deduction_d = this.GradeList.find(x => x.GradeID === 4).Deduction;
    // const deduction_e = this.GradeList.find(x => x.GradeID === 5).Deduction;
    // const deduction_n = this.GradeList.find(x => x.GradeID === 6).Deduction;

    // DeviceCategoryItem

    var DeviceCategoryItem:any=[];

    if (CategoryData && CategoryData.SkuModelData && CategoryData.SkuModelData.length > 0) {
      CategoryData.PriceEdit = "price-warning";
      CategoryData.SkuModelData.forEach(element => {
        element.MaxPrice = element.DeviceFullPrice;
        element.DeviceCategoryID = DeviceCategoryID,
          element.DeviceCategory = CategoryData.DeviceCategory,
          element.StartDate = formatteddate;
          element.EndDate = null;
        // element.Grade_A = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_a) / 100)).toFixed(2);
        // element.Grade_B = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_b) / 100)).toFixed(2);
        // element.Grade_C = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_c) / 100)).toFixed(2);
        // element.Grade_D = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_d) / 100)).toFixed(2);
        // element.Grade_E = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_e) / 100)).toFixed(2);
        // element.Grade_N = Math.round(element.MaxPrice - ((element.MaxPrice * deduction_n) / 100)).toFixed(2);
      });

      DeviceCategoryItem.SkuModelData = CategoryData.SkuModelData;
      DeviceCategoryItem.PriceEdit = "price-warning";
    } else {
      DeviceCategoryItem.SkuModelData = [];
      DeviceCategoryItem.PriceEdit = "";
    }


    this.spinner.hide();

  }


  returnPrice(item, a) {
   return (item.DeviceFullPrice - ((item.DeviceFullPrice * a.Deducation) / 100)).toFixed(2);
  }

  editPrice() {
    this.IsDisabled = false;
  }

  numbersonly(event: any) {
    const pattern = /^\d*(\.)?(\d{0,2})?$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // sendTheNewValue(event , price) {
  //   debugger;
  //   this.IsDisabled = false;
  //    this.IsSubmit = false;
  //   if (Number(event.target.value) > Number(price)) {
  //     event.target.classList.add('text-error');
  //     this.IsDisabled =  true;
  //     return;
  //   }
  //   event.target.classList.remove('text-edited');
  //   event.target.classList.remove('text-error');
  //   var val = Number(event.target.value);
  //   if (isNaN(val) === false) {
  //     event.target.classList.add('text-edited');
  //     event.target.value = val.toFixed(2);
  //   } else {
  //     event.target.classList.add('text-error');
  //     this.IsSubmit = false;
  //     this.IsDisabled =  true;
  //   }

  // }

  sendTheNewValue(element) {
    debugger;

    const GradeList = JSON.parse(sessionStorage.getItem('array'));
  
  const deduction_c = GradeList.find(x => x.GradeID === 1).Deduction;
  const deduction_d = GradeList.find(x => x.GradeID === 2).Deduction;
  const deduction_e = GradeList.find(x => x.GradeID === 3).Deduction;
  const deduction_n = GradeList.find(x => x.GradeID === 4).Deduction;
  element.Grade_C = (element.DeviceFullPrice - ((element.DeviceFullPrice * deduction_c) / 100)).toFixed(2);
  element.Grade_D = (element.DeviceFullPrice - ((element.DeviceFullPrice * deduction_d) / 100)).toFixed(2);
  element.Grade_E = (element.DeviceFullPrice - ((element.DeviceFullPrice * deduction_e) / 100)).toFixed(2);
  element.Grade_N =(element.DeviceFullPrice - ((element.DeviceFullPrice * deduction_n) / 100)).toFixed(2);


// var data=  this.GradeDataList.SkuModelData.filter(x=>x.SKUID==element.SKUID);

// if(data!=null && data.DeviceFullPrice!=null){



// }

    // this.IsDisabled = false;
    //  this.IsSubmit = false;
    // if (Number(event.target.value) > Number(price)) {
    //   event.target.classList.add('text-error');
    //   this.IsDisabled =  true;
    //   return;
    // }
    // event.target.classList.remove('text-edited');
    // event.target.classList.remove('text-error');
    // var val = Number(event.target.value);
    // if (isNaN(val) === false) {
    //   event.target.classList.add('text-edited');
    //   event.target.value = val.toFixed(2);
    // } else {
    //   event.target.classList.add('text-error');
    //   this.IsSubmit = false;
    //   this.IsDisabled =  true;
    // }

  }
  checPricelow(item, Grade) {

  }



  Searchfilter() {
    debugger
    // const filter = JSON.parse(sessionStorage.getItem('filter'));
    // if (filter && filter.length > 0) {
    //   this.DeviceCategoryList = filter;
    // } else {
    //   sessionStorage.setItem('filter', JSON.stringify(this.DeviceCategoryList));
    // }

    this.TemporaryData= JSON.parse(sessionStorage.getItem('TemporaryData'));
   // this.GradeDataList.SkuModelData =  this.TemporaryData;

    var categoryData = this.GradeDataList;

    if (this.SearchSKUID === '' && this.SearchMakeModel === '') {

      return;
    } else if (this.SearchSKUID !== '' && this.SearchMakeModel === '') {
      categoryData.SkuModelData = this.TemporaryData.filter(x => x.SKUID === Number(this.SearchSKUID));

    } else if (this.SearchSKUID === '' && this.SearchMakeModel !== '') {

      categoryData.SkuModelData = this.TemporaryData.filter(
        x => x.DeviceVendor === this.SearchMakeModel || x.DeviceModel === this.SearchMakeModel  );

    } else if (this.SearchSKUID !== '' && this.SearchMakeModel !== '') {
      categoryData.SkuModelData = this.TemporaryData.filter(x => x.SKUID === Number(this.SearchSKUID)
        && (x.DeviceVendor === this.SearchMakeModel || x.DeviceModel === this.SearchMakeModel)
      );
    }




    this.disableReset = false;
  }

  resetfilter() {
    this.spinner.show();
    this.SearchSKUID = '';
    this.SearchMakeModel = '';
    this.IsDisabled = true;
    //this.DeviceCategoryList = JSON.parse(sessionStorage.getItem('filter'));
    sessionStorage.removeItem('filter');
    this.getDisplaySkuPricedata(this.DeviceCategoryID);
    this.disableReset = true;
    //this.spinner.hide();

  }

  discardChanges() {

    this.SearchSKUID = '';
    this.SearchMakeModel = '';
    this.IsDisabled = true;
    this.disableReset = true;
    this.GradeDataList.SkuModelData= ''
    this.TemporaryData= JSON.parse(sessionStorage.getItem('TemporaryData'));
     this.GradeDataList.SkuModelData =  this.TemporaryData;
  }




Cancel()
{
  debugger
  this.GradeDataList.SkuModelData= ''
  this.TemporaryData= JSON.parse(sessionStorage.getItem('TemporaryData'));
   this.GradeDataList.SkuModelData =  this.TemporaryData;
}





}




